import { calculateTotalPassengers } from 'Util/_HumanWritten/CapacityCalculationUtils';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';

export const useIsPaxSpaceExceeded = (paxSpaceAvailable: number, wizardData: BookingWizardData) => {
	const paxCount = calculateTotalPassengers(wizardData);
	return paxCount > paxSpaceAvailable;
};
